// C.1 — Герой «Лидер улицы» (neutral_lider_ulicy).
//
// xlsx v6 dsl_aura:
//   value: buff_stats:1/0/0@ally_aoe_line_1 | buff_stats:0/1/1@ally_aoe_line_2
//   → На 1-й линии союзные юниты +1/0/0, на 2-й +0/1/1.
//   Реализация — в src/engine/keywords/street_leader_aura.js
//
// xlsx v6 dsl_active (Ф2, 1× за матч):
//   target: enemy_choose
//   effect: damage, value: 3
//   → 3 урона выбранному вражескому юниту.

import { registerImplementedAbility } from '../warn-unimplemented.js';
import { applyDamage } from '../../combat.js';

export const HERO_ID = 'neutral_lider_ulicy';

// Активка Героя в Ф2.
//   playerIdx — кто играет
//   targetUnit — выбранный вражеский юнит (передаёт UI/picker)
export function liderUlicyActive(state, playerIdx, targetUnit) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return { ok: false, reason: 'wrong_hero' };
  if (p.heroActiveUsedThisMatch) return { ok: false, reason: 'already_used' };
  if (p.hero.current?.silenced) return { ok: false, reason: 'silenced' };
  if (!targetUnit) return { ok: false, reason: 'no_target' };
  if (targetUnit.type !== 'unit') return { ok: false, reason: 'not_unit' };
  if (targetUnit.ownerId === playerIdx) return { ok: false, reason: 'not_enemy' };
  if (!targetUnit.isAlive?.()) return { ok: false, reason: 'target_dead' };

  applyDamage(targetUnit, 3, {
    state,
    source: { id: HERO_ID, name_ru: 'Лидер улицы' }
  });

  p.heroActiveUsedThisMatch = true;
  if (state.log) {
    state.log.add(`🔫 Лидер улицы [${p.name}]: активка — 3 урона ${targetUnit.name_ru}`);
  }
  return { ok: true };
}

export function liderUlicyActiveAvailable(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsedThisMatch) return false;
  if (p.hero.current?.silenced) return false;
  // Хотя бы один живой вражеский юнит должен быть на поле.
  const enemyIdx = 1 - playerIdx;
  const enemy = state.players?.[enemyIdx];
  if (!enemy?.field) return false;
  for (const row of enemy.field) {
    if (!row) continue;
    for (const u of row) {
      if (u && u.type === 'unit' && u.isAlive?.()) return true;
    }
  }
  return false;
}

// Список целей для UI-picker'а: все живые вражеские юниты.
export function getLiderUlicyActiveTargets(state, playerIdx) {
  const enemyIdx = 1 - playerIdx;
  const enemy = state.players?.[enemyIdx];
  if (!enemy?.field) return [];
  const out = [];
  for (const row of enemy.field) {
    if (!row) continue;
    for (const u of row) {
      if (u && u.type === 'unit' && u.isAlive?.()) out.push(u);
    }
  }
  return out;
}

registerImplementedAbility(HERO_ID, 'aura', 'active');
